import React from 'react';
import { useTranslation } from 'react-i18next';
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import SEO from "../../../utils/SEO";

export default function AssetProtectionServices() {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.assets-protection.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/assets-protection"
            />
            <IntroSection
                title={tp('intro.title')}
                subtitle={tp('intro.subtitle')}
                description={tp('intro.description')}
                badges={obj('intro.badges')}
                buttonText={tp('intro.button')}
                buttonLink="/quote"
                imageSrc={require('../../../assets/images/asset-protection/asset-protection.png')}
                imageAlt={tp('intro.imageAlt')}
            />


            <section className='section'>
                <div className="container">
                    <WhySection
                        title={tp('why.title')}
                        subtitle={tp('why.subtitle')}
                        blocks={[{ items: obj('why.items') }]}
                    />

                    <WhySection
                        title={tp('core.title')}
                        blocks={[{ items: obj('core.items') }]}
                    />

                    <InfoBlocks
                        title={tp('process.title')}
                        blocks={obj('process.blocks')}
                    />

                    <WhySection
                        title={tp('jurisdictions.title')}
                        blocks={[{ items: obj('jurisdictions.items') }]}
                    />


                    <FAQList data={obj('faq.items')} title={tp('faq.title')}/>

                    <Testimonials
                        title={tp('testimonials.title')}
                        testimonials={obj('testimonials.items')}
                    />

                    <CTA
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};
